import tokenConst from '@/constants/token';
import router from '@/router/index';
import store from '@/store/index';
import HttpStatus from 'http-status-codes';
import httpService from './httpService';
import tokenService from './tokenService';
import { captureException } from '@sentry/vue';
// @TODO: Refactor and simplify this logic
export default function interceptorSetup () {
    /**
   * @param response
   */
    const handleMaintenance = (response) => {
        if (response.headers[process.env.VUE_APP_MAINTENANCE_HEADER_NAME] !== undefined) {
            location.reload();
        }
    };

    httpService.interceptors.response.use(
        (response) => {
            handleMaintenance(response);
            return response;
        },
        (error) => {
            handleMaintenance(error.response);
            return Promise.reject(error);
        }
    );

    /**
   * @param response
   */
    const handleTokenTtl = (response) => {
        if (response?.headers?.[tokenConst.TOKEN_EXPIRATION_HEADER_NAME] === undefined) {
            return;
        }

        const tokenExpirationTimestamp = parseInt(
            response.headers[tokenConst.TOKEN_EXPIRATION_HEADER_NAME]
        );

        if (isNaN(tokenExpirationTimestamp) === true) {
            return;
        }

        tokenService.setTokenExpirationTimestamp(tokenExpirationTimestamp);
    };

    httpService.interceptors.response.use(
        (response) => {
            handleTokenTtl(response);
            return response;
        },
        (error) => {
            handleTokenTtl(error.response);
            return Promise.reject(error);
        }
    );

    httpService.interceptors.response.use(null, (error) => {
        const { status, responseURL, statusText, responseText } = error?.request || {};

        if (!status || !responseURL) {
            captureException(error);
            return Promise.reject(error);
        }

        const { name: currentRouteName } = router && router.currentRoute;
        const notFound = status === HttpStatus.NOT_FOUND;
        const badRequest = status === HttpStatus.BAD_REQUEST;
        const forbidden = status === HttpStatus.FORBIDDEN;
        const conflict = status === HttpStatus.CONFLICT;
        const unauthorized = status === HttpStatus.UNAUTHORIZED;
        const serverError = status === HttpStatus.INTERNAL_SERVER_ERROR;

        const connectFamily = notFound && responseURL.includes('connect-family');
        const previousEditions = notFound && responseURL.includes('previous-editions');
        const incorrectCsvImport =
      badRequest &&
      responseURL.includes('family-choice-path-import') &&
      responseURL.includes('verify');

        const loginPageBadRequest = badRequest && currentRouteName === 'login';
        const loginPageServerError = serverError && currentRouteName === 'login';
        const locationError = (notFound || forbidden || badRequest) && responseURL.includes('location');
        const warehouseNotFound = notFound && responseURL.includes('native-warehouse');

        const clearErrors =
      previousEditions ||
      connectFamily ||
      loginPageBadRequest ||
      locationError ||
      warehouseNotFound ||
      incorrectCsvImport;

        const pages = [
            'sheet-one-meeting',
            'sheet-one-reflection',
            'sheet-one-decision',
            'sheet-two',
            'family-description',
            'warehouse-data',
            'supporting-warehouse-data',
            'edit-warehouse-data',
            'edit-supporting-warehouse-data',
            'gift_giving_report',
            'specialist-package-lawyers',
            'specialist-package-medics'
        ];
        const documentsNotFound = notFound && pages.includes(currentRouteName);

        const warehouseConflicts =
      conflict &&
      [
          'warehouse-data',
          'supporting-warehouse-data',
          'edit-warehouse-data',
          'edit-supporting-warehouse-data'
      ].includes(currentRouteName);

        const forbiddenLogin = forbidden && currentRouteName === 'login';

        const sheetValidationErrors =
      badRequest &&
      [
          'sheet-one-meeting',
          'sheet-one-reflection',
          'sheet-one-decision',
          'sheet-two',
          'family-description',
          'gift_giving_report'
      ].includes(currentRouteName);

        if (clearErrors) {
            store.commit('clearErrors');
            return Promise.reject(error);
        } else if (documentsNotFound) {
            return Promise.reject(error);
        } else if (warehouseConflicts) {
            store.commit('clearErrors');
        } else if (loginPageServerError) {
            store.commit('setErrors', {
                status: '500_login',
                statusText,
                visible: true
            });
        } else if (forbiddenLogin) {
            store.commit('setErrors', {
                status: '403_login',
                statusText,
                visible: true
            });
            return Promise.reject(error);
        } else if (sheetValidationErrors) {
            store.commit('setErrors', {
                status,
                place: 'sheets',
                statusText,
                visible: true,
                responseText: JSON.parse(responseText)
            });
        } else {
            store.commit('setErrors', {
                status,
                statusText,
                visible: true
            });
        }

        const refreshError = unauthorized || responseURL.includes('auth/refresh');
        if (refreshError) {
            store.commit('setForcedToLogout', true);
            store.dispatch('logout').finally(() => {
                router.push({ name: 'login' });
            });
            return Promise.reject(error);
        }

        // Not handled errors - sent to Sentry
        captureException(error);
        return Promise.reject(error);
    });
}
